<div class="client-request-container" [dataSelector]="dataSelector + '-container'">
  <!-- Header section with name, description and counters -->
  <div class="client-request-header d-flex justify-content-between align-items-start w-100 mb-3">
    <!-- Left side: Name and description -->
    <div class="flex-grow-1 me-3 client-request-name-container" [ngClass]="{'is-fieldguide-request': isFieldGuideRequest$ | async}">
      <h3 class="client-request-name mb-1" [dataSelector]="dataSelector + '-name'" tooltipOverflow position="above">
        {{ displayName$ | async }}
      </h3>
      <p class="client-request-description text-muted mb-0" [dataSelector]="dataSelector + '-description'" tooltipOverflow position="above"
        [innerHTML]="instance.description$ | async | sanitizedHtml"></p>
    </div>

    <!-- Right side: Status counters with badges -->
    <div class="section-summary d-flex align-items-center gap-3" [dataSelector]="dataSelector + '-summary'">
      <span class="body-400 color-gray-100" tooltip="Open" [dataSelector]="dataSelector + '-open-count'">
        <awn-badge [dataSelector]="dataSelector + '-open-badge'"></awn-badge>
        {{ (itemStatusCounts$ | async)?.open }}
      </span>

      <span class="body-400 color-gray-100" tooltip="In Review" [dataSelector]="dataSelector + '-in-review-count'">
        <awn-badge color="yellow" [dataSelector]="dataSelector + '-in-review-badge'"></awn-badge>
        {{ (itemStatusCounts$ | async)?.inReview }}
      </span>

      <span class="body-400 color-gray-100" tooltip="Changes Requested" [dataSelector]="dataSelector + '-rejected-count'">
        <awn-badge color="red" [dataSelector]="dataSelector + '-rejected-badge'"></awn-badge>
        {{ (itemStatusCounts$ | async)?.rejected }}
      </span>

      <span class="body-400 color-gray-100" tooltip="Accepted" [dataSelector]="dataSelector + '-approved-count'">
        <awn-badge color="green" [dataSelector]="dataSelector + '-approved-badge'"></awn-badge>
        {{ (itemStatusCounts$ | async)?.approved }}
      </span>

      <!-- FieldGuide View button -->
      @if (isFieldGuideRequest$ | async) {
        <button
          andButton
          color="default"
          size="small"
          class="view-button d-flex align-items-center gap-2"
          [dataSelector]="dataSelector + '-fieldguide-view-button'"
          (click)="onViewInFieldGuide($event)"
          aria-label="View this request list in FieldGuide"
        >
          <aiwyn-icon
            [height]="16"
            [width]="16"
            name="fieldguide"
            namespace="app-catalog"
            class="fieldguide-icon"
            [dataSelector]="dataSelector + '-fieldguide-icon'"
            aria-hidden="true"
          ></aiwyn-icon>
          <span class="button-text">View</span>
        </button>
      }
    </div>
  </div>

  <!-- Bottom section with next due and overdue info -->
  <div class="d-flex justify-content-between align-items-center">
    <!-- Left side: Next Due -->
    <div class="d-flex align-items-center" [dataSelector]="dataSelector + '-next-due'">
      @let nextDueDate = instance.nextDueDate$ | async;
      <div class="d-flex align-items-center">
        <aiwyn-icon name="calendar" [height]="16" [width]="16" class="me-2 text-muted"></aiwyn-icon>
        <span class="text-muted">Next Due</span>
        @if (nextDueDate) {
          <span class="ms-2 fw-medium">{{ nextDueDate | date:'MM/dd/yyyy' }}</span>
        } @else {
          <span class="ms-2 fw-medium text-muted">--</span>
        }
      </div>

      <!-- Overdue pill - show when there are overdue items -->
      @let overdueCount = overdueCount$ | async;
      @if (overdueCount && overdueCount > 0) {
        <pill
          class="ms-2"
          color="yellow"
          size="medium"
          [value]="overdueCount > 1 ? `${overdueCount} requests overdue` : '1 request overdue'"
          [dataSelector]="dataSelector + '-overdue-pill'">
        </pill>
      }
    </div>

    <!-- Right side: Avatars -->
    <div class="d-flex align-items-center">
      <app-avatar
        nameStyle="full"
        [avatarInput]="requestItemsAvatars$ | async"
        [domain]="'contact'"
        [limit]="3"
        [showLabel]="false"
        [dataSelector]="dataSelector + '-avatars'"
      ></app-avatar>
    </div>
  </div>

  <!-- Second row for rejected items -->
  @if (rejectedItems$ | async; as rejects) {
    @if (rejects.length > 0 && showRejectedDetails) {
      <div class="rejected-items-row w-100 ms-12 mt-2" [dataSelector]="dataSelector + '-rejected-items-row'">
        <div class="rejected-items-container" [dataSelector]="dataSelector + '-rejected-items-container'">
          @for (item of rejects; track item) {
            <div class="d-flex mb-2">
              <!-- Name column -->
              <div class="rejected-item-name me-5" [dataSelector]="dataSelector + '-rejected-item-name'">
                {{ item.name }}
              </div>

              <!-- Reason column -->
              <div class="rejected-item-reason" [dataSelector]="dataSelector + '-rejected-item-reason'">
                {{ item.notes }}
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
